import {observer} from 'mobx-react-lite'
import {useParams} from 'react-router'
import clubStore from '../../../storage/ClubStore'
import React, {useEffect} from 'react'
import appStore from '../../../storage/AppStore'
import PageLayout from '../../PageLayout'

const AttendanceDetail = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.attendance.getAttendanceDetail(args.id)
  }, [args.id])
  
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  }
  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className={"m-0"}>{appStore.tr.attendance}</h3>
      </div>
    }>
      <div className="col-12">{clubStore.attendance.details?.title}, {formatDate(clubStore.attendance.query.date_from)} - {formatDate(clubStore.attendance.query.date_to)}</div>
      <div className="col-12">
        {appStore.tr.teams}: {clubStore.attendance.details?.teams?.map(team => team.name).join(', ')}
      </div>
      <div className="col-12">{appStore.tr.trainings}</div>
      <div className="col-12">
        <ul>
          {clubStore.attendance.details?.classes?.map(class_ => (
            <li key={class_.id}>
              {class_.team_name}, {class_.class_date}
            </li>
          ))
          }
        </ul>
      </div>
    </PageLayout>
  )
}

export default observer(AttendanceDetail)